/* eslint-disable jsx-a11y/label-has-associated-control */
import React, { useEffect, useState } from 'react';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import { SelectButton } from 'primereact/selectbutton';
import { InputText } from 'primereact/inputtext';
import { ArrowBackIos, Save } from '@mui/icons-material';
import { Grid, Tooltip } from '@mui/material';
import { DataTable } from 'primereact/datatable';
import { toast } from 'react-toastify';
import { Column } from 'primereact/column';
import WarningIcon from '@mui/icons-material/Warning';
import moment from 'moment';
import { Checkbox } from 'primereact/checkbox';
import {
  useAddSceneMutation,
  useEditSceneMutation,
  useGetSceneDetialsMutation
} from '../../../../services/scenes/sceneService';
import { IAddScene, IUpdateScene } from '../../../../types/Scenes/scenesTypes';
import { Header } from '../../../../components/header/header';
import {
  StyledHeaderContainer,
  StyledTitleHeader,
  styledColumnHeaderCheckboxWithLabel
} from '../../../../components/layout/main/mainStyles';
import { ButtonIconStyled } from '../../../../views/devices/devicesStyles';
import Strings from '../../../../i18n';
import { typeSceneEnum } from '../../../../constants/sceneEnums';
import {
  ContainerTable,
  ItemGridAddScene,
  StyledTitleLabelAddScene
} from './addSceneStyle';
import { useGetLightsZonesByLocationMutation } from '../../../../services/lightsZones/lightsZonesService';
import { SwitchOnOff } from '../../../../components/commons/SwitchOnOff/switchOnOff';
import { BrightnessSelectorBtn } from '../../../../components/commons/BrightnessSelector/brightnessSelector';
import { ColorSelector } from '../../../../components/commons/ColorSelector/ColorSelector';
import { LightCapabilitiesEnum } from '../../../../constants/commonEnums';
import { ILightZone } from '../../../../types/Lights/lightZoneInterfaces';
import {
  useSendColorCommandMutation,
  useSendBrightnessCommandMutation,
  useSendOnOffCommandMutation
} from '../../../../services/commandsService/commandsService';

export const AddSceneTemplate = () => {
  const navigate = useNavigate();
  const { locationId } = useParams();
  const [ignoredLights, setIgnoredLights] = useState<any[]>([]);
  const [sceneName, setSceneName] = useState<string>('');
  const [lightZonesList, setLightZonesList] = useState<ILightZone[]>([]);
  const optionsTypeScene = [typeSceneEnum.static, typeSceneEnum.playground];
  const [selectedTypeScene, setselectedTypeScene] = useState(
    typeSceneEnum.static
  );

  const { search } = useLocation();
  const queryParams = new URLSearchParams(search);
  const type = queryParams.get('type');
  const [sendCommandsToControllers, setSendCommandsToControllers] =
    useState<boolean>(type === Strings.scenes.live);

  const [postScene, { isSuccess }] = useAddSceneMutation();
  const [editScene, { isSuccess: isSuccessEditScene }] = useEditSceneMutation();
  const [getSceneDetails, { data }] = useGetSceneDetialsMutation();
  const [processedList, setProcessedList] = useState<ILightZone[]>([]);

  const [
    getLightsZonesByLocation,
    { isSuccess: isSuccessLightZones, data: dataLightsZones }
  ] = useGetLightsZonesByLocationMutation();

  const [setColor, { isSuccess: isSuccessSetColor }] =
    useSendColorCommandMutation();

  const [setBrightness, { isSuccess: isSuccessSetBrightness }] =
    useSendBrightnessCommandMutation();

  const [setSwitch, { isSuccess: isSuccessSetSwitch }] =
    useSendOnOffCommandMutation();

  const location = useLocation();
  const { sceneId } = location.state || {};

  useEffect(() => {
    if (locationId) {
      getLightsZonesByLocation(+locationId);
    }
  }, [locationId, getLightsZonesByLocation]);

  useEffect(() => {
    if (isSuccessLightZones && dataLightsZones) {
      setLightZonesList(dataLightsZones);
      setProcessedList(dataLightsZones);
    }
  }, [isSuccessLightZones, dataLightsZones]);

  useEffect(() => {
    if (sceneId) {
      getSceneDetails(sceneId);
    }
  }, [sceneId, getSceneDetails]);

  const postNewScene = () => {
    const payload: IAddScene = {
      locationId: locationId ? +locationId : 0,
      name: sceneName,
      sceneType: selectedTypeScene,
      lightZoneActions: processedList
        .filter((lz) => !ignoredLights.some((il) => il.id === lz.id))
        .map((lz) => ({
          id: lz.id,
          colorId: lz.colorId,
          lightBrightnessId: lz.lightBrightnessId,
          patternSpeed: lz.patternSpeed,
          lightingStatusId: lz.lightingStatusId,
          isZone: lz.isZone
        }))
    };
    postScene(payload);
  };

  const postOnFake = () => {
    const payload = {
      name: 'OffEvent 2',
      dateType: 1,
      weekDays: 127,
      timeType: 1,
      eventTime: '00:00',
      hour: 0,
      minute: 0,
      offsetMinutes: 0,
      sceneId: 0,
      startMonth: 1,
      startDay: 1,
      endMonth: 12,
      endDay: 31,
      holidayStartIndex: 0,
      holidayStartOffset: 0,
      holidayEndIndex: 0,
      holidayEndOffset: 0,
      locationId: 15147,
      daysOfWeek: 1111111,
      expiring: false,
      eventType: 1,
      lightingStatusId: 1,
      lightIds: [314]
    };
  };

  const setColorCommand = (info: {
    id: number;
    colorId: number;
    type: string;
  }) => {
    setProcessedList((prevList) =>
      prevList.map((lz) =>
        lz.id === info.id ? { ...lz, colorId: info.colorId } : lz
      )
    );
    if (sendCommandsToControllers) {
      setColor(info);
    }
  };

  const setSwitchCommand = (info: {
    id: number;
    method: string;
    type: string;
  }) => {
    setProcessedList((prevList) =>
      prevList.map((lz) =>
        lz.id === info.id
          ? { ...lz, lightingStatusId: info.method === 'On' ? 2 : 1 }
          : lz
      )
    );
    if (sendCommandsToControllers) {
      setSwitch(info);
    }
  };

  const setBrightnessCommand = (info: {
    brightness: number;
    id: number;
    type: string;
  }) => {
    setProcessedList((prevList) =>
      prevList.map((lz) =>
        lz.id === info.id ? { ...lz, lightBrightnessId: info.brightness } : lz
      )
    );
    if (sendCommandsToControllers) {
      setBrightness(info);
    }
  };

  useEffect(() => {
    if (!data || !lightZonesList.length) return;

    setSceneName(data.name);
    const newLights = lightZonesList.map((light) => {
      const action = data.lightZoneActions?.find((a) => a.id === light.id);
      if (action) {
        return {
          ...light,
          colorId: action.colorId,
          lightBrightnessId: action.lightBrightnessId,
          lightingStatusId: action.lightingStatusId,
          selected: !data.targets.some((t) => t.lightZoneId === light.id)
        };
      }

      return {
        ...light,
        selected: !data.targets.some((t) => t.lightZoneId === light.id)
      };
    });

    setProcessedList(newLights);

    const selectedLights = newLights.filter((l) => !!l.selected);
    setIgnoredLights(selectedLights);
  }, [data, lightZonesList]);

  const handleEditScene = () => {
    const payload: IUpdateScene = {
      sceneId,
      name: sceneName,
      lightZoneActions: processedList
        .filter((lz) => !ignoredLights.some((il) => il.id === lz.id))
        .map((lz) => ({
          id: lz.id,
          colorId: lz.colorId,
          lightBrightnessId: lz.lightBrightnessId,
          patternSpeed: lz.patternSpeed,
          lightingStatusId: lz.lightingStatusId,
          isZone: lz.isZone
        }))
    };
    editScene(payload);
  };

  const getCommands = (item: ILightZone) => {
    return (
      <div className="d-flex align-items-center my-1">
        <SwitchOnOff
          isOnLight={item.isOn}
          onSwitch={(value) =>
            setSwitchCommand({
              id: item.id,
              method: value ? 'On' : 'Off',
              type: item.isZone ? 'Zone' : 'Light'
            })
          }
        />
        <BrightnessSelectorBtn
          lightBrightnessId={item.lightBrightnessId}
          onChange={(brightnessId) =>
            setBrightnessCommand({
              brightness: brightnessId,
              id: item.id,
              type: item.isZone ? 'Zone' : 'Light'
            })
          }
        />
        <ColorSelector
          status={{
            colorId: item.colorId,
            patternSpeed: item.patternSpeed,
            sparkleDuration: item.sparkleDuration
          }}
          capabilities={[{ name: LightCapabilitiesEnum.EXTENDED_SOLID_COLORS }]}
          onColorChange={(colorId) => {
            setColorCommand({
              id: item.id,
              colorId,
              type: item.isZone ? 'Zone' : 'Light'
            });
          }}
        />
      </div>
    );
  };

  const getHeaderCheckbox = () => {
    return (
      <div className="d-flex align-items-center">
        <Checkbox
          className="p-checkbox"
          style={{
            visibility: 'visible',
            margin: '0 auto'
          }}
          checked={ignoredLights.length === lightZonesList.length}
          onChange={(e) =>
            setIgnoredLights(ignoredLights.length ? [] : lightZonesList)
          }
          inputId="ignoredLights"
        />
        <label
          htmlFor="ignoredLights"
          style={{ visibility: 'visible', marginLeft: '5px', marginBottom: 0 }}
        >
          Ignored
        </label>
      </div>
    );
  };

  useEffect(() => {
    if (isSuccess) {
      toast.success(Strings.scenes.sceneCreatedSuccess);
      navigate(-1);
    }
  }, [isSuccess]);

  useEffect(() => {
    if (isSuccessEditScene) {
      toast.success(Strings.scenes.sceneEditSuccess);
      navigate(-1);
    }
  }, [isSuccessEditScene]);

  useEffect(() => {
    if (isSuccessSetColor || isSuccessSetBrightness || isSuccessSetSwitch) {
      toast.success(Strings.commands.commandSentSuccessfully);
    }
  }, [isSuccessSetColor, isSuccessSetBrightness, isSuccessSetSwitch]);

  return (
    <div>
      <Header>
        <StyledHeaderContainer>
          <div className="row justify-content-between">
            <div className="col-4 text-left">
              <ButtonIconStyled size="small" onClick={() => navigate(-1)}>
                <ArrowBackIos />
              </ButtonIconStyled>
            </div>
            <div className="col-4 text-center">
              <StyledTitleHeader>
                {sceneId
                  ? Strings.scenes.editScene
                  : Strings.scenes.addSceneTitle}
              </StyledTitleHeader>
            </div>
            <div className="col-4 text-right">
              {(ignoredLights.length === lightZonesList.length ||
                !lightZonesList.length) && (
                <Tooltip title={Strings.scenes.noTargetScene}>
                  <ButtonIconStyled size="small" disabled={false}>
                    <WarningIcon color="warning" />
                  </ButtonIconStyled>
                </Tooltip>
              )}
              <ButtonIconStyled
                size="small"
                onClick={() => {
                  if (sceneId) {
                    handleEditScene();
                  } else {
                    postNewScene();
                  }
                }}
                disabled={
                  !sceneName || ignoredLights.length === lightZonesList.length
                }
              >
                <Save />
              </ButtonIconStyled>
            </div>
          </div>
        </StyledHeaderContainer>
      </Header>
      <Grid container>
        <ItemGridAddScene item xs={12}>
          <StyledTitleLabelAddScene>
            {Strings.scenes.sceneNameLabel}
          </StyledTitleLabelAddScene>
          <InputText
            className="w-100"
            value={sceneName}
            onChange={(e) => setSceneName(e.target.value)}
            placeholder={Strings.scenes.sceneNamePlaceholder}
          />
        </ItemGridAddScene>
        <ItemGridAddScene item xs={12}>
          <StyledTitleLabelAddScene>
            {Strings.scenes.typeSceneLabel}
          </StyledTitleLabelAddScene>
          <SelectButton
            value={selectedTypeScene}
            onChange={(e) => setselectedTypeScene(e.value)}
            options={optionsTypeScene}
          />
        </ItemGridAddScene>
        <ItemGridAddScene item xs={12}>
          <StyledTitleLabelAddScene className="text-center">
            {Strings.lightsZones.lightsZones}
          </StyledTitleLabelAddScene>
          <ContainerTable component="main">
            <DataTable
              selection={ignoredLights}
              selectionMode="multiple"
              metaKeySelection
              onSelectionChange={(e) => setIgnoredLights(e.value)}
              className="mt-3"
              rowHover
              scrollHeight="flex"
              value={processedList}
              size="small"
              scrollable
              paginator={processedList.length >= 50}
              selectionPageOnly
              tableStyle={{ padding: 0, margin: 0, fontSize: '14px' }}
            >
              <Column
                selectionMode="multiple"
                header={getHeaderCheckbox}
                headerStyle={styledColumnHeaderCheckboxWithLabel}
              />
              <Column field="name" header="Name" sortable />
              <Column field="typeName" header="Type" sortable />
              <Column field="" header="Commands" sortable body={getCommands} />
            </DataTable>
          </ContainerTable>
        </ItemGridAddScene>
      </Grid>
    </div>
  );
};
